<template>
  <iModal
    :visible="visible"
    title="Edit recurring event"
    :max-width="420"
    primary-action-button-label="OK"
    secondary-action-button-label="Cancel"
    :close-on-primary="false"
    :close-on-secondary="false"
    :primary-action-button-loading="isLoading"
    :primary-action-button-disabled="isLoading"
    @close="$emit('cancel')"
    @click:primary="$emit('confirm', chosenScope)"
    @click:secondary="$emit('cancel')"
  >
    <iColumn gap="standard">
      <iText v-if="summary" variant="subtle" font-size="small">
        {{ summary }}
      </iText>
      <iRadioButton
        v-for="option in scopeOptions"
        :key="option.value"
        v-model="chosenScope"
        name="event-save-scope"
        :value="option.value"
        :label="option.label"
        :data-test="`event-save-scope-${option.value}`"
      />
      <iText v-if="warning" variant="subtle" font-size="small">
        {{ warning }}
      </iText>
    </iColumn>
  </iModal>
</template>

<script>
import {
  SAVE_SCOPE_OPTIONS,
  SAVE_SCOPE_THIS_AND_FOLLOWING,
  SAVE_SCOPE_THIS_OCCURRENCE,
  SAVE_SCOPE_WHOLE_SERIES,
} from "%/constants/event-constants";

export default {
  name: "EventSaveScopeModal",
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    summary: {
      type: String,
      required: false,
      default: "",
    },
    isLoading: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  emits: ["confirm", "cancel"],
  data() {
    return {
      chosenScope: SAVE_SCOPE_THIS_OCCURRENCE,
      scopeOptions: SAVE_SCOPE_OPTIONS,
    };
  },
  computed: {
    warning() {
      if (this.chosenScope === SAVE_SCOPE_THIS_OCCURRENCE) {
        return "Only this one changes. The others stay as they are.";
      }

      if (this.chosenScope === SAVE_SCOPE_THIS_AND_FOLLOWING) {
        return "This one and every later one change. Earlier ones stay as they are, "
          + "and the series splits in two at this point.";
      }

      return "Every occurrence changes, including ones that have already happened.";
    },
  },
  watch: {
    visible(isVisible) {
      if (isVisible) {
        this.chosenScope = SAVE_SCOPE_THIS_OCCURRENCE;
      }
    },
  },
  created() {
    this.SAVE_SCOPE_WHOLE_SERIES = SAVE_SCOPE_WHOLE_SERIES;
  },
};
</script>
